import script from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=6778ce31&lang=scss"

const __exports__ = script;

export default __exports__